
import React, { useEffect, useState } from 'react';
import './FruitsAndVeg.css';
import Breadcrumb from '../../../../../components/Breadcrum';
import { Modal } from 'bootstrap';

export default function FruitsAndVeg() {
  const filterOptions = [
    { id: 'all', name: 'All' },
    { id: 'apples', name: 'Apples' },
    { id: 'pears', name: 'Pears' },
    { id: 'citrus', name: 'Citrus' },
    { id: 'grapes', name: 'Grapes' },
    { id: 'pomegranate', name: 'Pomegranate' },
    { id: 'strawberry', name: 'Strawberry' },
  ];

  const projects = [
    {
      id: 1,
      title: 'Red Delicious',
      category: 'apples',
      imageUrl: './assets/img/Fruits/Red-Delicious.png',
      description:
        'Red Delicious apples are mildly sweet, crunchy, and juicy. Known for their deep red color and smooth texture, they are ideal for fresh eating.',
      season: 'September to April',
      origin: 'USA, South Africa, Turkey, Chile, Poland, France, Italy',
    },
    {
      id: 6,
      title: 'Royal Gala',
      category: 'apples',
      imageUrl: './assets/img/Fruits/Royal-Gala.png',
      description:
        'Royal Gala apples are known for their crisp texture and natural sweetness. They are popular for snacks and salads.',
      season: 'August to February',
      origin: 'New Zealand, USA, Chile, Poland, France, Italy',
    },
    // {
    //   id: 7,
    //   title: 'Fuji',
    //   category: 'apples',
    //   imageUrl: './assets/img/Fruits/Fuji.png',
    //   description:
    //     'Fuji apples are very sweet, dense, and extremely juicy. They are popular dessert apples worldwide.',
    //   season: 'October to May',
    //   origin: 'Japan, USA, India (Kashmir)',
    // },
    {
      id: 2,
      title: 'Navel Orange',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Navel-Orange.png',
      description:
        'Navel oranges are sweet, seedless, and very juicy. They are rich in vitamin C and ideal for direct consumption.',
      season: 'November to June',
      origin: 'South Africa, Egypt, USA',
    },
    {
      id: 3,
      title: 'Mandarin Mini Orange',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Mandrin-Mini-Orange.png',
      description:
        'Mandarin oranges are easy to peel, sweet, and mildly tangy. They are perfect for snacking.',
      season: 'October to January',
      origin: 'Egypt, South Africa, China, Turkey, Morocco',
    },
    {
      id: 4,
      title: 'Grapefruits',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Grapefruits.png',
      description:
        'Grapefruit is a large citrus fruit with a tangy and slightly bitter flavor. It contains vitamin C and antioxidants.',
      season: 'November to April',
      origin: 'USA (Florida), South Africa, Turkey',
    },
    {
      id: 5,
      title: 'Lemon',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Lemon.png',
      description:
        'Fresh lemons are highly acidic, rich in vitamin C, and widely used in beverages and cooking.',
      season: 'Available year-round',
      origin: 'Turkey, South Africa, Argentina',
    },
    {
      id: 8,
      title: 'Pakham Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Pakham-Pear.png',
      description:
        'Pakham pears are soft, sweet, and juicy, with greenish-yellow skin. They are suitable for fresh eating and desserts.',
      season: 'March to October',
      origin: 'South Africa, USA, Australia',
    },
    {
      id: 9,
      title: 'Green / Red Beauty Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Green-Red-Beauty-Pear.png',
      description:
        'Beauty pears have a crisp texture, light sweetness, and refreshing flavor. They are often eaten fresh.',
      season: 'August to February',
      origin: 'South Africa',
    },
    {
      id: 10,
      title: 'William Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/William-Pear.png',
      description:
        'William pears are juicy, sweet, and aromatic, with smooth yellow-green skin.',
      season: 'August to February',
      origin: 'South Africa',
    },
    {
      id: 11,
      title: 'Asian Pear Korea',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Asian-Pear-Korea.png',
      description:
        'Asian pears are round, crisp, and extremely juicy, with a sweet, aromatic flavor.',
      season: 'August to January',
      origin: 'South Korea, Thailand',
    },
    {
      id: 12,
      title: 'Red Grapes',
      category: 'grapes',
      imageUrl: './assets/img/Fruits/Red-Grapes.png',
      description:
        'Red grapes are large and round with a bluish-pink color and few seeds, typically two to three per grape. They are sweet, juicy, and crunchy.',
      season: 'July to August',
      origin: 'As specified by the supplier',
      containerType: '40 feet reefer container',
      containerCapacity:
        '3,600 boxes/baskets of 4.5 kg each, as per customer packaging demand',
      availableSizes: '24 mm',
    },
    {
      id: 13,
      title: 'Green Grapes',
      category: 'grapes',
      imageUrl: './assets/img/Fruits/Green-Grapes.png',
      description:
        'Green grapes are pale yellow-green, seedless, medium-sized oval fruits with a light, sweet flavor and crisp skin.',
      season: 'May to June',
      origin: 'As specified by the supplier',
      containerType: '40 feet reefer container',
      containerCapacity:
        '3,600 boxes/baskets of 4.5 kg each, as per customer packaging demand',
      availableSizes: '18 mm',
    },
    {
      id: 14,
      title: 'Pomegranate',
      category: 'pomegranate',
      imageUrl: './assets/img/Fruits/Pomegranate.png',
      description:
        'Pomegranate is a nearly round, medium-to-large fruit with deep pink, leathery skin. Its interior contains juicy, dark pink seeds surrounded by white, spongy tissue. The edible seeds are crunchy, sweet, and berry-like in flavor, with a pleasantly tart taste.',
      season: 'September to December',
      origin: 'As specified by the supplier',
      containerType: '40 feet reefer container',
      containerCapacity:
        '4,000 boxes/baskets of 4.5 kg each, as per customer packaging demand',
      availableCounts: '6, 7, 8, 9, 10, 11, 12, 13, 14, 15',
    },
    {
      id: 15,
      title: 'Strawberry',
      category: 'strawberry',
      imageUrl: './assets/img/Fruits/Strawberry.png',
      description:
        'Strawberries are aggregate fruits made up of several small fruits. They are delicious, nutrient-rich, and known for their appealing flavor.',
      season: 'December to April',
      origin: 'As specified by the supplier',
      containerType: '40 feet reefer container',
      containerCapacity:
        '25 metric tons, as per customer packaging demand',
      availableSizes: '25–35 mm per piece',
    },
  ];

  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const openModal = (product) => {
    setSelectedProduct(product);

    setTimeout(() => {
      const modalElement = document.getElementById('productModal');

      if (modalElement) {
        Modal.getOrCreateInstance(modalElement).show();
      }
    }, 100);
  };

  return (
    <div>
      <Breadcrumb
        title="EGYPT VALLEY GOODS"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="container py-5">
        <div className="row justify-content-center mb-5">
          <div className="filter-btns shadow-md rounded-pill text-center col-auto">
            {filterOptions.map((filter) => (
              <button
                key={filter.id}
                type="button"
                className={`filter-btn btn rounded-pill btn-outline-primary border-0 m-md-2 px-md-4 ${activeFilter === filter.id ? 'active shadow' : ''
                  }`}
                onClick={() => handleFilterClick(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>

        <div className="row projects g-lg-3 g-md-3 g-0">
          {projects
            .filter(
              (project) =>
                activeFilter === 'all' ||
                project.category === activeFilter
            )
            .map((project, index) => (
              <div
                key={project.id}
                className="col-lg-4 col-md-6 col-12 project"
                style={{
                  animationDelay: `${index * 0.2}s`,
                  cursor: 'pointer',
                }}
                onClick={() => openModal(project)}
              >
                <div className="service-work overflow-hidden card mb-lg-0 mb-3">
                  <img
                    className="card-img-top"
                    src={project.imageUrl}
                    alt={project.title}
                  />

                  <div className="card-body">
                    <h5 className="card-title light-300 text-dark">
                      {project.title}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Bootstrap Product Modal */}
      <div
        className="modal fade"
        id="productModal"
        tabIndex="-1"
        aria-labelledby="productModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title" id="productModalLabel">
                {selectedProduct?.title}
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {selectedProduct && (
                <div className="row">
                  <div className="col-12 text-center mb-3">
                    <img
                      src={selectedProduct.imageUrl}
                      alt={selectedProduct.title}
                      className="img-fluid rounded"
                    />
                  </div>

                  <div className="col-12">
                    {selectedProduct.description && (
                      <p>
                        <strong>Description:</strong>{' '}
                        {selectedProduct.description}
                      </p>
                    )}

                    {selectedProduct.origin && (
                      <p>
                        <strong>Origin:</strong>{' '}
                        {selectedProduct.origin}
                      </p>
                    )}

                    {selectedProduct.season && (
                      <p>
                        <strong>Season:</strong>{' '}
                        {selectedProduct.season}
                      </p>
                    )}

                    {selectedProduct.containerType && (
                      <p>
                        <strong>Container Type:</strong>{' '}
                        {selectedProduct.containerType}
                      </p>
                    )}

                    {selectedProduct.containerCapacity && (
                      <p>
                        <strong>Container Capacity:</strong>{' '}
                        {selectedProduct.containerCapacity}
                      </p>
                    )}

                    {selectedProduct.availableSizes && (
                      <p>
                        <strong>Available Sizes:</strong>{' '}
                        {selectedProduct.availableSizes}
                      </p>
                    )}

                    {selectedProduct.availableCounts && (
                      <p>
                        <strong>Available Counts:</strong>{' '}
                        {selectedProduct.availableCounts}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
